function toggleFilter() {
  let x = document.querySelector(".sq-filter-main");
  x.classList.toggle("opening");
}
function toggleClass() {
  let y = document.querySelector(".sq-filter-main");
  y.classList.remove("opening");
}
function removeClass() {
  let z = document.querySelector(".sq-filter-main");
  z.classList.remove("opening");
}

function sqListView() {
  const app = document.querySelector(".sparq-container");
  app.classList.add("--list-view");
}

window.sq = window.sq || {};

window.sq.initSearch = (store) => {
  store.search();
};
(function (XHR) {
    "use strict";

    const originalOpen = XHR.prototype.open;
    const originalSend = XHR.prototype.send;

    const SPECIAL_SUGGESTION_COLLECTION = "8LKMZL1CLU4DQNZLKDLU5UAL";
    const IN_STOCK_COLLECTION = "8DT3S97RC6AAQ9ZWZPP2V3AF";

    const SEARCH_AND_COLLECTION_SORT =
        "-meta_qty_sold_last_90_days__joxrgiwewwwussy1mpqgfhub";

    XHR.prototype.open = function (method, url) {
        this._sparqUrl = String(url);
        return originalOpen.apply(this, arguments);
    };

    XHR.prototype.send = function (data) {
        const requestUrl = this._sparqUrl || "";

        if (
            requestUrl
                .toLowerCase()
                .includes("7ilas8um8a85fpvgarfl5n4m.fast.sparq.ai/v2")
        ) {
            try {
                const body =
                    typeof data === "string" ? JSON.parse(data) : data;

                console.log("Original Sparq payload:", body);
                console.log("Original Sparq filter:", body?.filter);

                /*
                 * Remove in_stock = 1 from all requests except
                 * collection 8DT3S97RC6AAQ9ZWZPP2V3AF.
                 */
                if (
                    body?.collection !== IN_STOCK_COLLECTION &&
                    typeof body?.filter === "string"
                ) {
                    body.filter = body.filter
                        .split(/\s+AND\s+/i)
                        .filter(function (condition) {
                            return !/^\s*\(?\s*in_stock\s*=\s*(1|true)\s*\)?\s*$/i.test(
                                condition
                            );
                        })
                        .join(" AND ")
                        .trim();
                }

                /*
                 * Make sure in_stock = 1 exists for
                 * collection 8DT3S97RC6AAQ9ZWZPP2V3AF.
                 */
                if (body?.collection === IN_STOCK_COLLECTION) {
                    const existingFilter =
                        typeof body.filter === "string"
                            ? body.filter.trim()
                            : "";

                    const hasInStockFilter =
                        /(?:^|\s+AND\s+)\(?\s*in_stock\s*=\s*(1|true)\s*\)?(?:\s+AND\s+|$)/i.test(
                            existingFilter
                        );

                    if (!hasInStockFilter) {
                        body.filter = existingFilter
                            ? `${existingFilter} AND in_stock = 1`
                            : "in_stock = 1";
                    }

                    console.log(
                        "In-stock collection filter:",
                        body.filter
                    );
                }

                const currentLocation = window.location.href;

                const isSearchPage =
                    currentLocation.includes("/search");

                const isAllPage =
                    currentLocation.includes("/all");

                const isInStockCollection =
                    body?.collection === IN_STOCK_COLLECTION;

                const collectionHandle = currentLocation.includes(
                    "/collections/"
                )
                    ? currentLocation
                          .split("/collections/")[1]
                          .split("?")[0]
                          .split("#")[0]
                    : null;

                /*
                 * Sort search page results and products from
                 * collection 8DT3S97RC6AAQ9ZWZPP2V3AF
                 * by quantity sold in the last 90 days.
                 */
                if (isSearchPage || isInStockCollection) {
                    body.sort = [SEARCH_AND_COLLECTION_SORT];

                    console.log(
                        "Applied 90-day sales sorting:",
                        body.sort
                    );
                }

                /*
                 * Apply collection-specific sorting to all other
                 * collection pages.
                 */
                if (
                    !isSearchPage &&
                    !isAllPage &&
                    collectionHandle &&
                    !isInStockCollection
                ) {
                    const collectionSort =
                        "sortOrderFor_" +
                        collectionHandle.replaceAll("-", "_");

                    const sorting = Array.isArray(body.sort)
                        ? [...body.sort]
                        : [];

                    if (!sorting.includes(collectionSort)) {
                        sorting.push(collectionSort);
                    }

                    body.sort = sorting;

                    console.log(
                        "Applied collection sorting:",
                        body.sort
                    );
                }

                /*
                 * Special suggestion collection configuration.
                 * Keep this block after all other sorting logic
                 * because it must override body.sort with -rank.
                 */
                if (body?.collection === SPECIAL_SUGGESTION_COLLECTION) {
                    const currentQuery = body.query || "";

                    body.collection = SPECIAL_SUGGESTION_COLLECTION;
                    body.query = currentQuery;
                    body.sort = ["-rank"];
                    body.fields = [
                        "suggestion",
                        "count",
                        "source",
                        "sourceFields"
                    ];
                    body.count = 8;
                    body.filter = "";
                    body.filters = [];
                    body.geo = {};
                    body.searchFields = [];

                    console.log(
                        "Updated special collection payload:",
                        body
                    );
                }

                console.log("Updated Sparq filter:", body.filter);
                console.log("Updated Sparq sorting:", body.sort);
                console.log("Updated Sparq payload:", body);

                data = JSON.stringify(body);
            } catch (error) {
                console.error(
                    "Could not modify Sparq request:",
                    error
                );
            }
        }

        return originalSend.call(this, data);
    };
})(XMLHttpRequest);

// (function (XHR) {
//     "use strict";

//     const originalOpen = XHR.prototype.open;
//     const originalSend = XHR.prototype.send;

//     const SPECIAL_SUGGESTION_COLLECTION = "8LKMZL1CLU4DQNZLKDLU5UAL";
//     const IN_STOCK_COLLECTION = "8DT3S97RC6AAQ9ZWZPP2V3AF";

//     XHR.prototype.open = function (method, url) {
//         this._sparqUrl = String(url);
//         return originalOpen.apply(this, arguments);
//     };

//     XHR.prototype.send = function (data) {
//         const requestUrl = this._sparqUrl || "";

//         if (
//             requestUrl
//                 .toLowerCase()
//                 .includes("7ilas8um8a85fpvgarfl5n4m.fast.sparq.ai/v2")
//         ) {
//             try {
//                 const body =
//                     typeof data === "string" ? JSON.parse(data) : data;

//                 console.log("Original Sparq filter:", body?.filter);

//                 /*
//                  * Remove in_stock = 1 from all requests except
//                  * collection 8DT3S97RC6AAQ9ZWZPP2V3AF.
//                  */
//                 if (
//                     body?.collection !== IN_STOCK_COLLECTION &&
//                     typeof body?.filter === "string"
//                 ) {
//                     body.filter = body.filter
//                         .split(/\s+AND\s+/i)
//                         .filter(function (condition) {
//                             return !/^\s*\(?\s*in_stock\s*=\s*(1|true)\s*\)?\s*$/i.test(
//                                 condition
//                             );
//                         })
//                         .join(" AND ")
//                         .trim();
//                 }

//                 /*
//                  * Make sure in_stock = 1 exists for the specified collection.
//                  */
//                 if (body?.collection === IN_STOCK_COLLECTION) {
//                     const existingFilter =
//                         typeof body.filter === "string"
//                             ? body.filter.trim()
//                             : "";

//                     const hasInStockFilter =
//                         /(?:^|\s+AND\s+)\(?\s*in_stock\s*=\s*(1|true)\s*\)?(?:\s+AND\s+|$)/i.test(
//                             existingFilter
//                         );

//                     if (!hasInStockFilter) {
//                         body.filter = existingFilter
//                             ? `${existingFilter} AND in_stock = 1`
//                             : "in_stock = 1";
//                     }

//                     console.log(
//                         "In-stock collection filter:",
//                         body.filter
//                     );
//                 }

//                 const currentLocation = window.location.href;

//                 const collectionHandle = currentLocation.includes(
//                     "/collections/"
//                 )
//                     ? currentLocation
//                           .split("/collections/")[1]
//                           .split("?")[0]
//                           .split("#")[0]
//                     : null;

//                 if (
//                     !currentLocation.includes("/search") &&
//                     !currentLocation.includes("/all") &&
//                     collectionHandle
//                 ) {
//                     const collectionSort =
//                         "sortOrderFor_" +
//                         collectionHandle.replaceAll("-", "_");

//                     const sorting = Array.isArray(body.sort)
//                         ? [...body.sort]
//                         : [];

//                     if (!sorting.includes(collectionSort)) {
//                         sorting.push(collectionSort);
//                     }

//                     body.sort = sorting;
//                 }

//                 if (body?.collection === SPECIAL_SUGGESTION_COLLECTION) {
//                     const currentQuery = body.query || "";

//                     body.collection = SPECIAL_SUGGESTION_COLLECTION;
//                     body.query = currentQuery;
//                     body.sort = ["-rank"];
//                     body.fields = [
//                         "suggestion",
//                         "count",
//                         "source",
//                         "sourceFields"
//                     ];
//                     body.count = 8;
//                     body.filter = "";
//                     body.filters = [];
//                     body.geo = {};
//                     body.searchFields = [];

//                     console.log(
//                         "Updated special collection payload:",
//                         body
//                     );
//                 }

//                 console.log("Updated Sparq filter:", body.filter);

//                 data = JSON.stringify(body);
//             } catch (error) {
//                 console.error(
//                     "Could not modify Sparq request:",
//                     error
//                 );
//             }
//         }

//         return originalSend.call(this, data);
//     };
// })(XMLHttpRequest);

setTimeout(() => {
  if (document.querySelector(".sq-filter-main"))
    document.querySelector(".sq-filter-main").style.visibility = null;
  if (document.querySelector(".sparq-container"))
    document.querySelector(".sparq-container").style.visibility = null;
  if (document.querySelector(".sq-app.sq-dropdown"))
    document.querySelector(".sq-app.sq-dropdown").style.visibility = null;
}, 800);

window.addEventListener("keydown", (e) => {
  if (e.key === "Escape") {
    document.querySelector("footer").click();
  }
});

setTimeout(() => {
  if (location.href.includes("/search?q=")) {
    let url = new URL(location.href);
    let params = new URLSearchParams(url.search);
    let q = params.get("q"); // 'mdn query string'
    document.querySelector("#search2").value = q;
  }
}, 200);

window.sq.hidePagination = function (store) {
  setTimeout(() => {
    const sparqContainer = document.querySelector(".sparq-container");
    document.querySelectorAll(".sparq-container form").forEach((e) => {
      theme.AddItemToCart(e);
    });

    if (sparqContainer && store.currentPage == 1) {
      sparqContainer.classList.add("sq-hide-prev");
    } else {
      sparqContainer.classList.remove("sq-hide-prev");
    }

    if (store.currentPage === store.totalPages) {
      sparqContainer.classList.add("sq-hide-next");
    } else {
      sparqContainer.classList.remove("sq-hide-next");
    }
  }, 200);

  return true;
};

setTimeout(() => {
  const listBtn = document.querySelector('[aria-label="List"]');
  const gridBtn = document.querySelector('[aria-label="Grid"]');
  // const sqSort = document.querySelector(".sq-sort");

  if (!listBtn) return;
  listBtn.addEventListener("click", () => {
    const app = document.querySelector(".sparq-container");
    app.classList.add("--list-view");
    app.classList.remove("--grid-view");
  });
  gridBtn.addEventListener("click", () => {
    const app = document.querySelector(".sparq-container");
    app.classList.remove("--list-view");
    app.classList.add("--grid-view");
  });
  if (listBtn.classList.contains("is-selected")) listBtn.click();
  if (gridBtn.classList.contains("is-selected")) gridBtn.click();
  // listBtn.append(sqSort);
}, 500);

window.sq.loadImage = function (item) {
  const sparqCard = document.querySelector(
    `.sparq-card[product-handle="${item.handle}"]`
  );
  setTimeout(() => {
    sparqCard
      .querySelector(".sparq-thumbnail-wrap")
      .classList.remove("zoom-fade-animation");
  }, 500);
};


window.sq.setBrandURL = function (item) {
  const collection = location.pathname.split("/");
  const collectionHandle = collection[collection.length - 1];

  // Convert vendor to lowercase
  const vendor = (item.vendor || "").trim().toLowerCase();

  let baseURL = `${location.origin}/collections/${collectionHandle}`;

  // If currently on search page, redirect to /collections/all
  if (location.href.includes("/search")) {
    baseURL = `${location.origin}/collections/all`;
  }

  // URLSearchParams converts spaces to "+"
  const params = new URLSearchParams();
  params.set("system_vendor", vendor);

  return `${baseURL}?${params.toString()}`;
};

setTimeout(() => {
  document.querySelector('[name="q"]').addEventListener("keydown", (e) => {
    if (e.keyCode === 13) {
      console.log("Enter key pressed!");
      e.stopPropagation();
      e.preventDefault();
      location.href = location.origin + "/search?q=" + e.target.value;
    }
    toggleDropdown();
  });
}, 200);

function toggleDropdown() {
  setTimeout(() => {
    if (document.querySelector('[name="q"]').value.length > 0) {
      document.querySelector(".sq-app.sq-dropdown").style.display = null;
    } else {
      document.querySelector(".sq-app.sq-dropdown").style.display = "none";
    }
  }, 200);
}

window.sq.updatePrice = function (searchResults) {
  const fetchData = searchResults.results.map((r) => {
    return fetch(`/products/${r.handle}.js`)
      .then((res) => res.json())
      .then((d) => {
        // Assuming you want the price of the first variant
        const variant = d.variants[0];
        r.price = parseFloat(variant.price) / 100; // Shopify returns price in cents
        r.compare_at_price = parseFloat(variant.compare_at_price) / 100 || null;
        changePrice(r);
      })
      .catch((e) => {
        console.error(`Failed to fetch data for ${r.handle}: ${e}`);
      });
  });
  return searchResults.results;
};

function changePrice(item) {
  const sparqCard = document.querySelector(
    `.sparq-card[product-handle="${item.handle}"]`
  );

  const priceElement = sparqCard.querySelector(".sq-price");
  const comparePriceElement = sparqCard.querySelector(".sq-compare-price");

  if (priceElement) {
    priceElement.classList.add("loaded");
    priceElement.innerHTML = item.price.toLocaleString("en-US", {
      style: "currency",
      currency:
        Shopify.currency.active == "CAD" ? "USD" : Shopify.currency.active,
    });
  }

  if (comparePriceElement && item.compare_at_price) {
    comparePriceElement.classList.add("loaded");
    comparePriceElement.innerHTML = item.compare_at_price.toLocaleString(
      "en-US",
      {
        style: "currency",
        currency: "USD",
      }
    );
  }

  if (
    item.compare_at_price &&
    item.compare_at_price > item.price &&
    typeof sqSave !== "undefined" &&
    typeof notLoyalityTag !== "undefined"
  ) {
    sqSave.innerHTML = `(You save ${(
      item.compare_at_price - item.price
    ).toLocaleString("en-US", { style: "currency", currency: "USD" })})`;
    notLoyalityTag.style.display = "block";
  }
}

// function updateDropdown() {
//   const products = document.querySelectorAll(
//     '.sq-dropdown-body .sq-results-item'
//   );

//   const banners = document.querySelectorAll(
//     '.sq-dropdown-body .sq-banner'
//   );

//   const maxProducts = window.innerWidth <= 767 ? 2 : 3;

//   // Products
//   products.forEach((product, index) => {
//     product.style.display = index < maxProducts ? '' : 'none';
//   });

//   // Hide all banners
//   banners.forEach((banner) => {
//     banner.style.display = 'none';
//   });

//   // Show banner after last visible product
//   const bannerIndex = maxProducts;

//   if (banners[bannerIndex]) {
//     banners[bannerIndex].style.setProperty(
//       'display',
//       'block',
//       'important'
//     );
//   }
// }

// setInterval(updateDropdown, 100);

// DROPDOWN BANNER

// (function () {
//   "use strict";

//   const dropdownSelector = ".sq-dropdown-body";

//   function isCollectionItem(item) {
//     return (
//       item.classList.contains("sq-collection-item") ||
//       item.matches('[data-type="collection"]') ||
//       item.querySelector(".sq-collection-item") ||
//       item.querySelector('[data-type="collection"]') ||
//       item.className.toLowerCase().includes("collection")
//     );
//   }

//   function updateDropdown() {
//     const dropdown = document.querySelector(dropdownSelector);

//     if (!dropdown) return;

//     const allResults = Array.from(
//       dropdown.querySelectorAll(".sq-results-item")
//     );

//     // Only products. Collection cards are excluded.
//     const products = allResults.filter((item) => {
//       return !isCollectionItem(item);
//     });

//     const banners = Array.from(
//       dropdown.querySelectorAll(".sq-banner")
//     );

//     const maxProducts = window.innerWidth <= 767 ? 2 : 3;

//     products.forEach((product, index) => {
//       product.style.setProperty(
//         "display",
//         index < maxProducts ? "" : "none",
//         index < maxProducts ? "" : "important"
//       );
//     });

//     // Keep collection results visible
//     allResults
//       .filter(isCollectionItem)
//       .forEach((collection) => {
//         collection.style.removeProperty("display");
//       });

//     // Hide all banners first
//     banners.forEach((banner) => {
//       banner.style.setProperty("display", "none", "important");
//     });

//     // Show the required banner
//     const bannerIndex = maxProducts;

//     if (banners[bannerIndex]) {
//       banners[bannerIndex].style.setProperty(
//         "display",
//         "block",
//         "important"
//       );
//     }
//   }

//   let updateTimer;

//   function scheduleUpdate() {
//     clearTimeout(updateTimer);

//     updateTimer = setTimeout(updateDropdown, 50);
//   }

//   const observer = new MutationObserver(scheduleUpdate);

//   function initializeDropdownObserver() {
//     const dropdown = document.querySelector(dropdownSelector);

//     if (!dropdown) {
//       setTimeout(initializeDropdownObserver, 300);
//       return;
//     }

//     observer.observe(dropdown, {
//       childList: true,
//       subtree: true
//     });

//     updateDropdown();
//   }

//   initializeDropdownObserver();

//   window.addEventListener("resize", scheduleUpdate);
// })();

